import type { Lang, LorsCopy } from "./translations";

export type May29Headline = { headline: string; subhead: string };

export const may29Headlines: May29Headline[] = [
  {
    headline:
      "California Probate Can Cost Your Family $40,000 or More. Learn How to Avoid It — Free.",
    subhead:
      "If you own a home in California, your family may be one missed step away from an 18-month court process and tens of thousands in legal fees. In this free webinar, we'll show you the exact steps to protect your home and pass everything to your family without probate court — starting May 29th.",
  },
  {
    headline:
      "Your Bay Area Home Could Trigger Probate Court — Even If You Have a Will.",
    subhead:
      "California's probate threshold is just $184,500. If you own a home here, you're almost certainly above it. That means without a properly funded trust, your family faces court — guaranteed. This free webinar shows you exactly how to close that gap before May 29th.",
  },
  {
    headline:
      "How to Pass Your Home Directly to Your Children — Without Probate Court, Delays, or Legal Fees.",
    subhead:
      "Your home is likely your largest asset. Without the right plan, your kids could spend 18+ months and tens of thousands in court just to receive it. In this free webinar, we'll show you the straightforward legal steps to make sure it goes directly to them — the way you intend.",
  },
  {
    headline:
      "Most California Homeowners Don't Know This Could Silently Drain Their Family's Inheritance.",
    subhead:
      "It's not a scam or a tax — it's probate. A court process that quietly takes a percentage of everything you own before a single dollar reaches your family. In this free webinar, we'll show you exactly what it is, who it affects, and the one step that stops it.",
  },
  {
    headline:
      "Avoid Probate. Protect Your Home. Here's Your Free Seat for May 29th.",
    subhead:
      "You already know probate is something to avoid. Now learn the exact legal steps California homeowners use to protect their homes and pass everything to their families without court involvement. Free. Live. May 29th. Reserve your seat below.",
  },
  {
    headline:
      "California Changed Its Probate Laws in 2025. Here's What It Means for Your Family's Home.",
    subhead:
      "New legislation took effect in April 2025 — and while it helps some California families, most Bay Area homeowners are still fully exposed to probate court. Find out where you stand and what to do about it in this free live webinar on May 29th.",
  },
  {
    headline:
      "Without a Living Trust, a California Judge Has the Final Say Over Your Home and Your Assets.",
    subhead:
      "Probate is a public, court-supervised process. That means a judge decides the timeline, the costs, and ultimately what goes where — not you. A properly funded living trust puts that control back in your hands. We'll show you exactly how it works in our free webinar on May 29th.",
  },
  {
    headline:
      "18 Months in Court. Thousands in Fees. Here's How California Homeowners Skip Probate Entirely.",
    subhead:
      "Probate is not inevitable — it's a choice. With the right legal structure in place, your home, accounts, and assets can pass directly to your family without a single court appearance. This free webinar shows you exactly how, in plain English, on May 29th.",
  },
  {
    headline:
      "Your Life's Work Deserves to Go to Your Family — Not to a Probate Court.",
    subhead:
      "You've spent a lifetime building something worth protecting. A simple legal step taken today can ensure your home, your savings, and your legacy pass to the people you love — privately, quickly, and exactly as you intend. Join us May 29th to learn how.",
  },
  {
    headline:
      "There's One Simple Legal Step That Keeps Your Home Out of Probate Court. We'll Show You Exactly What It Is.",
    subhead:
      "It doesn't require an expensive retainer or a stack of paperwork you don't understand. Most California homeowners can protect their home with a single, properly structured legal document. In this free webinar on May 29th, we walk you through the whole thing — simply and clearly.",
  },
];

const baseEn = {
  eyebrow: "Free Estate Planning Webinar",
  headline: may29Headlines[0].headline,
  headlineBreakBefore: "Learn How to Avoid It",
  subhead: may29Headlines[0].subhead,
  subheadLabel: "A note from Ruby:",
  learnTitle: "What Most California Homeowners Don't Realize Until It's Too Late",
  learnItems: [
    "Why a will alone won't keep your home out of California probate court",
    "How a properly funded living trust passes your home directly to your family — no court, no delays",
    "The 2025 California probate law changes and what they mean for Bay Area homeowners",
    "California probate fees on a $700,000 estate can exceed $46,000. A solid estate plan? A fraction of that — and your family gets everything, faster.",
  ],
  quote:
    "Ruby Steinbrecher was fantastic. The family trust workshop was clear, informative, and extremely helpful for getting started with estate planning.",
  quoteAttribution: "Shawn H., Workshop Attendee",
  formDate: { short: "Fri, May 29th", long: "Friday, May 29th" },
  formTime: "12:00 PM PT",
  formVenueLine1: "Live Online Webinar",
  formVenueLine2: "Join from anywhere — link sent after registration",
  formTitle: "Reserve Your Seat",
  formSubtitle: "Free to attend. Limited spots available.",
  formFirstName: "First name",
  formLastName: "Last name",
  formEmail: "Email",
  formPhone: "Phone",
  formSmsConsent:
    "I consent to receive text messages from the Law Office of Ruby Steinbrecher about this event, and occasional marketing messages. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
  formEnewsConsent:
    "I'd like to receive occasional email updates from the Law Office of Ruby Steinbrecher.",
  formPrivacy: "Privacy Policy",
  formSubmit: "Reserve My Seat",
  formSubmitting: "Reserving your seat…",
  formTrust: "⭐ Trusted by local families | 81 Five-Star Reviews",
  getDirections: "",
  footerCopyright: "© 2026 Ruby Steinbrecher",
  footerPrivacy: "Privacy Policy",
  testimonialsTitle: "What Families Are Saying",
  aboutTitle: "Meet Ruby Steinbrecher",
  aboutRole: "Attorney",
  aboutBody: [
    "I have practiced law since 2007, first working at a medium-sized firm in San Francisco handling civil litigation, and then moving into estate planning, small business and contract law since 2010. I value people, the planet, and prosperity that does not adversely affect the former.",
    "Prior to entering the legal field, I had a variety of business and life experience that has only enhanced my ability to serve clients: Road Manager for Ken Kesey's bus trip to Great Britain in 1999, Human Resources at a tech startup in 2001, recognized for my work as a Case Manager at Casey Family Programs with disadvantaged youth in the foster care system in Oakland and the wider San Francisco-Bay Area in the early 2000's.",
    "Currently, I live in Sebastopol with my daughter, husband, and a menagerie of pets, where I enjoy gardening as it keeps me grounded and enjoying the beautiful weather.",
  ],
  registrationTitle: "Ready to Secure Your Family's Future?",
  registrationSub: "Free to attend. Limited spots available.",
  registrationCta: "Save My Seat",
  registrationFoot:
    "No pressure. Just clear information so you can make the right decision for your family.",
  errorTitle: "Something went wrong",
  errorBody:
    "We couldn't reserve your seat. Please try again or call our office.",
  validation: {
    firstName: "First name is required",
    lastName: "Last name is required",
    email: "Enter a valid email",
    phone: "Enter a valid phone number",
  },
  timeAgo: {
    monthAgo: "a month ago",
    monthsAgo: (n: number) => `${n} months ago`,
    yearAgo: "a year ago",
  },
};

export const lorsContentMay29 = { en: baseEn, es: baseEn } as unknown as Record<Lang, LorsCopy>;

export const getMay29Copy = (hParam: string | null): LorsCopy => {
  const n = Number(hParam);
  const idx = Number.isInteger(n) && n >= 1 && n <= may29Headlines.length ? n - 1 : 0;
  const pick = may29Headlines[idx];
  return { ...baseEn, headline: pick.headline, subhead: pick.subhead } as unknown as LorsCopy;
};
